import { useQuery } from "@tanstack/react-query";
import { Button, Empty, message, Spin, Typography } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";

import ROUTES from "shared/routes";
import { getRequests } from "../api";
import styles from "./index.module.scss";

export const RequestsList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["requests"],
    queryFn: () => getRequests({ filter: "in_progress" }),
  });

  useEffect(() => {
    if (isError) {
      messageApi.error(
        (error as any)?.response?.data?.message ||
          "An error occurred while receiving the list of requests",
      );
    }
  }, [isError, error, messageApi]);

  if (isLoading) {
    return (
      <div className={styles.listWrapperLoader}>
        {contextHolder}
        <Spin />
      </div>
    );
  }

  return !data?.data?.length ? (
    <div className={styles.listWrapper}>
      {contextHolder}
      <Empty
        description={
          <Typography.Text>
            {isError
              ? (error as any)?.response?.data?.message ||
                t("requests.error_message")
              : t("requests.list_empty")}
          </Typography.Text>
        }
      />
    </div>
  ) : (
    <div className={styles.list}>
      {data?.data?.map((item) => (
        <div
          className={styles.listItem}
          key={item.id}
          onClick={() => {
            navigate(
              generatePath(ROUTES.REQUEST_ID, {
                requestNumber: item.number,
              }),
            );
          }}
        >
          <div className={styles.head}>
            <div className={styles.taskNumber}>
              {t("requests.request_number")} {item.number}
            </div>
          </div>

          <div className={styles.title}>{item.name}</div>

          <div className={styles.date}>
            {t("requests.start_date")}:{" "}
            {moment(item.date_start).format("DD.MM.YYYY")} {item.time_start}
          </div>
          <div className={styles.date}>
            {t("requests.end_date")}:{" "}
            {moment(item.date_finish).format("DD.MM.YYYY")} {item.time_finish}
          </div>

          <div className={styles.footer}>
            <Button
              block
              className={styles.viewButton}
              onClick={() => {
                navigate(
                  generatePath(ROUTES.REQUEST_ID, {
                    requestNumber: item.number,
                  }),
                );
              }}
            >
              {t("requests.view_button")}
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
